// extracted by mini-css-extract-plugin
export default {"disc":"upload_disc__8SOKW","uploadBtn":"upload_uploadBtn__mLdSw","uploadText":"upload_uploadText__R7jp6"};